import { PdfExportService } from '../../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../../services/user.service';
var LatestPostsComponent = /** @class */ (function () {
    function LatestPostsComponent(pdfService, userService) {
        this.pdfService = pdfService;
        this.userService = userService;
        this.latestPosts = [];
        this.forPayingUser = false;
    }
    Object.defineProperty(LatestPostsComponent.prototype, "hasNoData", {
        get: function () {
            return this.latestPosts.length === 0
                || (this.forPayingUser && this.userService.isFreeUser() && !this.userService.isAdmin);
        },
        enumerable: true,
        configurable: true
    });
    LatestPostsComponent.prototype.ngAfterViewInit = function () {
        this.pdfService.incrementNumberReportReady(LatestPostsComponent.COMPONENT_NAME);
    };
    LatestPostsComponent.COMPONENT_NAME = 'LatestPosts';
    return LatestPostsComponent;
}());
export { LatestPostsComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/latest-posts/latest-posts.component.ts.pre-build-optimizer.js